import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepTripCancellationAndTripInterruption = (state) => state.get('stepTripCancellationAndTripInterruption');

const makeSelectStepTripCancellationAndTripInterruption = () => createSelector(
  selectStepTripCancellationAndTripInterruption,
  (stepTripCancellationAndTripInterruptionState) => ({
    tripCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'tripCancellation']),
      ''
    ),

    reasonForTripCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'reasonForTripCancellation']),
      ''
    ),

    reasonForTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'reasonForTravelCancellation']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasons: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasons']),
      ''
    ),

    dateTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateTravelCancellation']),
      ''
    ),

    nameOfPersonHavingSicknessTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'nameOfPersonHavingSicknessTravelCancellation']),
      ''
    ),

    dateOfBirthTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateOfBirthTravelCancellation']),
      ''
    ),

    relationshipToClaimantTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'relationshipToClaimantTravelCancellation']),
      ''
    ),

    dateSicknessOrInjuryBeganTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateSicknessOrInjuryBeganTravelCancellation']),
      ''
    ),

    dateEndedTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateEndedTravelCancellation']),
      ''
    ),

    natureOfSicknessOrInjuryTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'natureOfSicknessOrInjuryTravelCancellation']),
      ''
    ),

    fromDateTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'fromDateTravelCancellation']),
      ''
    ),

    toDateTravelCancellation: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'toDateTravelCancellation']),
      ''
    ),

    lossInformationItemsTravelCancellation: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'lossInformationItemsTravelCancellation']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'lossInformationItemsTravelCancellation']).toJS(), ''),
    insuredsTravelCancellation: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'insuredsTravelCancellation']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'insuredsTravelCancellation']).toJS(), ''),
    enableTimeTravelCancellation: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'enableTimeTravelCancellation']), null),

    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'tripCancellationForAnyReason']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasonsForAnyReason: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasonsForAnyReason']),
      ''
    ),

    dateTripCancellationForAnyReason: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateTripCancellationForAnyReason']),
      ''
    ),

    reasonForTripCancellationForAnyReason: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'reasonForTripCancellationForAnyReason']),
      ''
    ),

    lossInformationItemsTripCancellationForAnyReason: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']).toJS(), ''),
    insuredsTripCancellationForAnyReason: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'insuredsTripCancellationForAnyReason']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'insuredsTripCancellationForAnyReason']).toJS(), ''),
    travelSuppliersTripCancellationForAnyReason: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'travelSuppliersTripCancellationForAnyReason']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'travelSuppliersTripCancellationForAnyReason']).toJS(), ''),

    // Trip Interruption
    travelInterruption: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'travelInterruption']),
      ''
    ),

    reasonsForTripInterruption: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'reasonsForTripInterruption']),
      ''
    ),

    dateTripInterrupted: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateTripInterrupted']),
      ''
    ),

    reasonForInterruption: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'reasonForInterruption']),
      ''
    ),

    nameOfPersonHavingSickness: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'nameOfPersonHavingSickness']),
      ''
    ),

    dateOfBirth: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateOfBirth']),
      ''
    ),

    relationshipToClaimant: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'relationshipToClaimant']),
      ''
    ),

    dateSicknessOrInjuryBegan: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),

    dateEnded: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateEnded']),
      ''
    ),

    natureOfSicknessOrInjury: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'natureOfSicknessOrInjury']),
      ''
    ),

    periodOfHospitalization: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'periodOfHospitalization']),
      ''
    ),

    fromDate: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      stepTripCancellationAndTripInterruptionState,
      () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'toDate']),
      ''
    ),

    insuredsForInterruption: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'insuredsForInterruption']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'insuredsForInterruption']).toJS(), ''),
    travelSuppliersTravelInterruption: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'travelSuppliersTravelInterruption']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'travelSuppliersTravelInterruption']).toJS(), ''),
    enableTimeInterruption: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'enableTimeInterruption']), null),
    lossInformationItems: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'lossInformationItems']) && stepTripCancellationAndTripInterruptionState.getIn(['form', 'lossInformationItems']).toJS(), ''),

    companyNameLoss: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'currentAmountOfLoss']), ''),
    amountClaimed: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'amountClaimed']), ''),
    currentClaimed: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'currentClaimed']), ''),
    haveYouReceivedReimbursement: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(stepTripCancellationAndTripInterruptionState, () => stepTripCancellationAndTripInterruptionState.getIn(['form', 'enableTime']), null),
  })
);

const makeSelectStepTripCancellationAndTripInterruptionErrors = () =>
  createSelector(selectStepTripCancellationAndTripInterruption, (state) => state.get('errors'));

export {
  makeSelectStepTripCancellationAndTripInterruption,
  makeSelectStepTripCancellationAndTripInterruptionErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTripCancellationAndTripInterruption/selectors.js